import React from 'react';
import SoloStartTimeSelectContainer from '../organisms/soloStartTimeSelectContainer';
import { SubHeader } from '../molecules/subHeader';
import SubHeader1 from '../../resources/image/subHeader1.png';
import { GolfSoloHeaderContainer } from '../organisms/golfSoloHeaderContainer';
import GolfSoloReservationPopupContainer from '../organisms/golfSoloReservationPopupContainer';

class SoloStartTimeSelectTemplate extends React.Component {
    render() {
        return (
            <>
                <GolfSoloHeaderContainer
                    categoryLabel1={"スタート時間"} Label
                    categoryLabel2={"TEE TIME"}
                    path={"/reserve/golf/soloSearch"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow} />
                <SubHeader SubImage={SubHeader1} />
                <SoloStartTimeSelectContainer
                    reserveType={"reserve"}
                />
                <GolfSoloReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                />
            </>
        )
    }
}
export default SoloStartTimeSelectTemplate;